import { render, staticRenderFns } from "./TipoBarniz.vue?vue&type=template&id=4ec8856e&"
import script from "./TipoBarniz.vue?vue&type=script&lang=js&"
export * from "./TipoBarniz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports